import type { ErrorRouteComponent } from '@tanstack/react-router'
import { BackgroundOrnaments } from '../decorative/background-ornaments'
import { LinkButton } from '../ui/button/link-button'
import { ErrorView } from '../ui/error-view'
import { Text } from '../ui/text'

export const UnexpectedError: ErrorRouteComponent = ({ error }) => {
  return (
    <>
      {/* TanStack router doesn't render Root component at all (makes sense because the React tree throws error), so BackgroundOrnament has to be specified again */}
      <BackgroundOrnaments />

      <main>
        <ErrorView
          title="Something went wrong"
          description={
            <div>
              <p>Reload the page and try again, or return to the home page.</p>

              <details className="mt-8">
                <summary className="cursor-pointer">
                  <Text size={12} font="nbArchitekt" color="gold">
                    Technical details
                  </Text>
                </summary>
                <div className="mt-2 bg-black text-white w-full overflow-x-auto border border-white/10 font-mono rounded-lg p-4">
                  <pre className="text-xs">{error.message}</pre>
                </div>
              </details>
            </div>
          }
          button={
            <LinkButton to="/" className="w-full">
              Back to Home
            </LinkButton>
          }
        />
      </main>
    </>
  )
}
